<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Select Action Type Outcome Option</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Action Type:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                disabled
                label="name"
                name="action_type"
                :options="action_types"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="optionDescription.action_type"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Outcome:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select
                disabled
                label="name"
                name="outcome"
                :options="outcomes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="optionDescription.outcome"
                data-vv-as="Outcome"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Option:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <div v-for="(option, index) in options" :key="index">
                <vs-checkbox
                  class="mb-2"
                  name="option"
                  v-model="optionDescription.option"
                  :vs-value="option"
                  v-validate="'required'"
                  >{{ option.name }}</vs-checkbox
                >
              </div>
            
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('option')"
              >{{ errors.first("option") }}</span
            >
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <vs-divider class="m-5" />

          <DataGrid :context="'ActionTypeOutcomeOption'" 
            ref="optionDescription"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleActionTypeManagement from "@/store/action-type-management/moduleActionTypeManagement.js";
import moduleOutcomeManagement from "@/store/outcome-management/moduleOutcomeManagement.js";
import moduleAuditTrialManagement from "@/store/audit-trial-management/moduleAuditTrialManagement.js";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      selected_outcome_id:null,
      optionDescription: [],
      outcomes: [],
      action_types: [],
      companySearchComponentKey: 0,
      columnDefs: [
        //    {
        //   headerName: "Actions",
        //   field: "transaction",
        //   cellRenderer: "CellRendererActions",
        //   suppressHeaderMenuButton: true,
        //   pinned: true,
        //   width: 100
        // },
        {
          headerName: "Action Type",
          field: "action_type",
          flex: 1,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Outcome",
          field: "outcome",
          flex: 1,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Option",
          field: "option",
          flex: 1,

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      all_options: [
        {
          slug: "submit",
          name: "Submit"
        },
        {
          slug: "schedule_a_next_action",
          name: "Schedule a Next Action"
        },
        {
          slug: "no_i_dont_to_schedule_a_next_action",
          name: "No, I don't want to schedule a next action"
        },
        {
          slug: "next",
          name: "Next"
        }
      ],
      options: [],
      dataSource: {},
      records: [],
      selected: [],
      abilities: null,
      optionDescription: {
        action_type: null,
        outcome: null,
        option: []
      },
      option_id: null
    };
  },
  components: {
    "v-select": vSelect,
    moduleOutcomeManagement,
    DataGrid
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleOutcomeManagement.isRegistered) {
      this.$store.registerModule("OutcomesManagement", moduleOutcomeManagement);
      moduleOutcomeManagement.isRegistered = true;
    }

    if (!moduleActionTypeManagement.isRegistered) {
      this.$store.registerModule(
        "ActionTypesManagement",
        moduleActionTypeManagement
      );
      moduleActionTypeManagement.isRegistered = true;
    }

    if (!moduleAuditTrialManagement.isRegistered) {
      this.$store.registerModule(
        "AuditTrialsManagement",
        moduleAuditTrialManagement
      );
      moduleAuditTrialManagement.isRegistered = true;
    }
  },
  mounted() {
    this.fetchAllActionTypes();
    this.option_id = this.$route.params.optionId;

    this.fetchOptionsById();
  },
  watch: {
   
  },
  methods: {
    fetchOutcome() {
      let self = this;
      self.$store
        .dispatch("OutcomesManagement/fetchOutcomes", this.selected_outcome_id)
        .then(res => {
          let result = JSON.parse(res.data);
          if (result) {
            self.selected_options = result[0].action_type_outcome_option;

            let seloption = [];

            self.all_options.forEach(function(ele) {
              if (self.selected_options.includes(ele.slug)) {
                seloption.push(ele);
              }
            });

            self.options = seloption;

            // console.log("sdfsfsdf" , seloption)
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    fetchOptionsById() {
      let self = this;

      this.$store
        .dispatch("AuditTrialsManagement/fetchOptionsById", self.option_id)
        .then(res => {
          let result = res.data;
          self.optionDescription = result;

          self.action_types.forEach(function(ele) {
            if (ele.id == self.optionDescription.action_type_id) {
              self.optionDescription.action_type = ele;
            }
          });

          self.fetchAllOutcomesByActionType(
            self.optionDescription.action_type_id
          );

          self.selected_outcome_id = self.optionDescription.outcome_id;
          self.fetchOutcome();



          let selected_option = [];

          self.all_options.forEach(function(ele) {
            if (self.optionDescription.option.includes(ele.slug)) {
              selected_option.push(ele);
            }
          });

          self.optionDescription.option = selected_option;
        })
        .catch(err => {
          console.error(err);
        });
    },
    fetchAllOutcomesByActionType(action_type_id) {
      var self = this;
      self.$store
        .dispatch(
          "OutcomesManagement/getAllOutcomesByActionype",
          action_type_id
        )
        .then(function(response) {
          let response_data = response.data;
          self.outcomes = response_data;

          self.outcomes.forEach(function(ele) {
            if (ele.id == self.optionDescription.outcome_id) {
              self.optionDescription.outcome = ele;
            }
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch(
              "AuditTrialsManagement/getAllActionTypeOptions",
              params.request
            )
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.optionDescription.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.optionDescription.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.selectActionTypeOutcomeOption();
        }
      });
    },
    fetchAllActionTypes() {
      var self = this;
      self.$store
        .dispatch("OutcomesManagement/getAllActionTypesForOutcomes")
        .then(function(response) {
          let response_data = response.data;
          self.action_types = response_data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    selectActionTypeOutcomeOption() {
      this.optionDescription.action_type_id = this.optionDescription.action_type.id;
      this.optionDescription.outcome_id = this.optionDescription.outcome.id;

      let outcome_option = [];
      this.optionDescription.option.map(function(ele) {
        outcome_option.push(ele.slug);
      });
      this.optionDescription.option = outcome_option;

      this.$store
        .dispatch(
          "AuditTrialsManagement/updateActionTypeOutcomeOption",
          this.optionDescription
        )
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Option",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Option",
              text: "The Action Type Outcome Option was added successfully"
            });
            this.$router.push({
              path: "/audit_trial/action_type_outcome_option"
            });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
